module.exports = __webpack_public_path__ + "static/media/preguntas.e8ce22c8.png";